import React from 'react';
import { IconProps } from '.';

const SvgCircleWon = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m10.143 16.23 1.321-4.112h.863l1.091 4.076 1.439.036 1.321-4.112H18v-1.5h-1.34l.768-2.388L16 7.77l-.915 2.848h-1.607l-.753-2.812-1.439-.036-.915 2.848H8.764L8.01 7.806l-1.449.388.65 2.424H6v1.5h1.612l1.092 4.076 1.439.036Zm-.978-4.112h.723l-.394 1.227-.329-1.227Zm5.043 1.227-.328-1.227h.723l-.395 1.227Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleWon;
